import styled from "@emotion/styled";
import React from "react";
import { Spinner } from "react-bootstrap";

type ChartBoxProps = JSX.IntrinsicAttributes & {
    className?: string;
    ref?: any;
    style?: any;
};

export const WidgetContainer = styled.div`
    padding: 16px 20px 16px 18px;
    color: #fff;
    min-height: 210px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const WidgetHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    grid-area: header;
`;

export const WidgetTitle = styled.div`
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1;
`;

export const WidgetSubtitle = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: #828FAB;
    line-height: 1;
    margin-top: 5px;
    height: 17px;
`;

export const WidgetContent = styled.div`
`;

const ChartDraggable = styled.div`
    width: 100%;
    padding: 6px 0;
    cursor: move;
    position: absolute;
    z-index: 1;
`;

const WidgetBox = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ChartBoxProps>>(
    ({ children, className, ...rest }, ref) => {
        return (
            <div className={`col ${className}`} ref={ref} {...rest}>
                <ChartDraggable className="widget-drag" />
                {children}
            </div>
        );
    }
);

const StyledSpinner = styled(Spinner)`
    position: inherit;
    color: #00cbaf;
`;

/** Wraps the Bootstrap spinner in `<output>` for a status live region without relying on `role="status"` on the spinner alone. */
export function CustomSpinner(props: React.ComponentProps<typeof StyledSpinner>) {
    const { role: _omitRole, ...spinnerProps } = props;
    return (
        <output>
            <StyledSpinner {...spinnerProps} />
        </output>
    );
}

export default WidgetBox;
